window.addEventListener("load", function () {
  var $fl = $("#libraryMainsite-t-float_left");
  if ($fl.length === 0) return;

  $fl.on("click", ".fl-toggle", function (e) {
    e.preventDefault();
    $fl.toggleClass("collapsed");
  });

  function bindSwiper(retry) {
    var el = document.querySelector(".main-swiper");
    var sw = el && el.swiper;
    if (!sw) {
      if (retry < 30) setTimeout(function () { bindSwiper(retry + 1); }, 100);
      return;
    }
    function sync() {

      $fl.toggleClass("fl-hidden", sw.activeIndex === 0);
    }
    sync();
    sw.on("slideChange", sync);
  }
  bindSwiper(0);
});
